import feeds from './feeds/feeds';
import webshops from './webshops/webshops';
import connections from './connections/connections';

const clients = {
    'clients.add': 'Invite customer',
    'clients.add.explanation': 'Enter a company name and contact person to send an invitation.',

    'client.attention.needed': 'Attention needed',

    'clients.company': 'My company',

    'clients.company.subscription': 'Subscription',
    'clients.company.subscription.plan': 'Subscription plan',

    'clients.company.subscription.choose.option': 'Choose this option',

    'clients.company.subscription.type.yearly': 'Yearly',
    'clients.company.subscription.type.once': 'Once',
    'clients.company.subscription.type.free': 'Free',

    'clients.company.subscription.payment_interval': 'Paid per',
    'clients.company.subscription.payment_interval.year': 'Year',
    'clients.company.subscription.payment_interval.yearly': 'Year',
    'clients.company.subscription.payment_interval.month': 'Month',
    'clients.company.subscription.payment_interval.once': 'One time',
    'clients.company.subscription.payment_interval.free': 'n/a',

    'clients.company.subscription.yearly.description': 'Active for 1 year. Choose your own scale size of products. (Price per month excl. vat)',
    'clients.company.subscription.once.description': 'Active for 1 week. Choose your own scale size of products.',
    'clients.company.subscription.free.description': 'Demo version. Active for 1 week for a total of 10 products.',

    'clients.subscription.payment_plan': 'Payment plan',
    'clients.subscription.days_valid': 'Days valid',
    'clients.subscription.update_payment_plan': 'Update payment plan',
    'clients.subscription.valid_till_today': 'Till today',
    'clients.subscription.expired': 'Expired',

    'clients.pricing.explanation': 'Here you can change the gross price without discount. Existing B2B prices and potential B2B discounts are still valid',
    'clients.notation.explanation': 'This is to seperate the prices with a Comma or Dot example: €12,34',

    ...feeds,
    ...webshops,
    ...connections,
};

export default clients;
